import { validateMemberDetailService } from "../api/common";
import { tostW } from "../config/tostConfig";

const useMemberValidation = () => {
  const handleValidateMemberDetail = async (email, phone) => {
    try {
      const params = {
        email,
        phone,
      };
      const res = await validateMemberDetailService(params);
      if (res.status === 200 && res.data.success) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const isMemberDetailsValid = async (values) => {
    try {
      if (values?.member_mobile_1 && values?.member_email_1) {
        const isMember1Exists = await handleValidateMemberDetail(
          values.member_email_1,
          values.member_mobile_1
        );
        if (!isMember1Exists) {
          tostW("Member 1 Mobile/Email are not associate with any eema member");
          return false;
        }
      }
      if (values?.member_mobile_2 && values?.member_email_2) {
        const isMember2Exists = await handleValidateMemberDetail(
          values.member_email_2,
          values.member_mobile_2
        );
        if (!isMember2Exists) {
          tostW("Member 2 Mobile/Email are not associate with any eema member");
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      tostW("Unable to verify member details");
      return false;
    }

    return true;
  };
  return { handleValidateMemberDetail, isMemberDetailsValid };
};

export default useMemberValidation;
